export const selectCorrespondenceLanguage = state =>
  state.customerDetail.data.personal.language;
export const selectCustomerDetails = state => state.customerDetail.data;
export const selectCustomerDetailsPersonal = state =>
  state.customerDetail.data.personal;
export const selectIsFetching = state => state.customerDetail.isFetching;
